import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

export function handleArrayBufferError<ArrayBuffer>() {
  return (source: Observable<HttpResponse<ArrayBuffer>>): Observable<ArrayBuffer> => {
    return source.pipe(
      map((response) => {
        if (response.status < 400) {
          return response.body as ArrayBuffer; // Return the body as the expected type
        }
      }),
      catchError((error) => {
        if (error.error instanceof ArrayBuffer) {
          const text = new TextDecoder().decode(error.error);
          try {
            const json = JSON.parse(text);
            return throwError(() => json);
          } catch {
            return throwError(() => error.error);
          }
        }
        return throwError(() => error.error); // Return regular error for non-ArrayBuffer cases
      })
    );
  };
}
